import type {LoginTokens} from "@/adapters/auth.adapter";
import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";

export const loginService = async (username: string, password: string): Promise<TResponseRequest<LoginTokens>> => {
  return httpRequest.post<LoginTokens>({
    url: `${config.apiBaseUrl}/bo/auth/login`,
    body: {username, password},
    isPublic: true,
  });
};

export const refreshTokenService = async (refreshToken: string): Promise<TResponseRequest<LoginTokens>> => {
  return httpRequest.post<LoginTokens>({
    url: `${config.apiBaseUrl}/bo/auth/refresh-token`,
    body: {refreshToken},
    isPublic: true,
  });
};

export const logoutService = async (refreshToken: string): Promise<TResponseRequest<void>> => {
  return httpRequest.post<void>({
    url: `${config.apiBaseUrl}/bo/auth/logout`,
    body: {refreshToken},
  });
};
